import React from 'react';

const getClassName = ({type, ...props}) => {
  let baseClass = "pda-card";
  const defaultType = "medium";
  const defaultTheme = "light";

  if(props.className) {
    return props.className
  }
  else {
    if(type && ["header", "body", "footer"].includes(type)) {
      return `${baseClass}-${type}`;
    } else {
      let className = "";
      if(props.type && ["small", "medium", "large"].includes(props.type)) {
        className = `${baseClass}-${props.type}`;
      }
      if(props.theme && ["light","dark"].includes(props.theme)) {
        className = `${className}-${props.theme}`
      }
      className = `${baseClass}-${defaultType}-${defaultTheme}`;
      
      return className;
    }
  }
}

const Card = (props) => {
  return (
    <div className={getClassName({...props})}>
      { props.children }
    </div>
  )
}


const Header = (props) => {
  return (
    <header className={getClassName({type:"header", ...props})}>
      {props.children}
    </header>
  )
}

const Body = (props) => {
  return (
    <header className={getClassName({type:"body", ...props})}>
      {props.children}
    </header>
  )
}

Card.Header = Header;
Card.Body = Body;

export default Card
